<template>
  <div>
    <Header :is-wide="true" />
    <div class="container-full row-start align-start">
      <div class="main-no-side">
        <div class="border-radius-m px-2_5 py-2_5 has-bg-white">
          <div class="container my-10">
            <div class="col-start">
              <div class="my-2_5" style="width: 600px; max-width: 100%;">
                <el-input
                  v-model="search"
                  class=""
                  placeholder="搜索模板，一键复制"
                  style="max-width: 100%;"
                  @change="onSearch(null)"
                >
                  <template #append>
                    <el-button @click="onSearch(null)"><i class="iconfont icon-search" /></el-button>
                  </template>
                </el-input>
              </div>
              <div>
                <el-button type="primary" plain @click="onCreate()"><i class="iconfont icon-plus" /> 空白表单</el-button>
                <!-- <el-button type="default" plain @click="onService()"><i class="iconfont icon-customerservice" /> 免费录入服务</el-button> -->
                <a class="el-button el-button--default is-plain" href="https://work.weixin.qq.com/kfid/kfc4c8482f0f4854c58" target="_blank">
                  <span class="iconfont icon-customerservice" /> 客服协助
                </a>
                <!-- <div
                  class="border-a border-radius-m text-center cursor-hand has-bg-white has-text-dark px-4 inline-block no-shrink"
                  style="height: 40px; line-height: 40px; user-select: none;"
                  @click="onCreate()"
                >
                  <span>新建空白表单</span>
                </div> -->
              </div>
            </div>

          </div>
        </div>

        <div class="container my-2_5">
          <div class="border-radius-m my-2_5 mx-2_5 px-4 py-2_5 has-bg-white my-loading">
            <div class="">
              <div class="inline-block row-wrap">
                <el-link v-for="(item, index) in scenList" :key="index" :type="scenValue === item.value ? 'primary' : 'default'" :underline="false" class="mr-5 my-2_5" @click="onChangeScen(item)">
                  {{ item.label }}
                </el-link>
              </div>
            </div>
            <!-- <div class="">
              <div class="inline-block row-wrap">
                <el-link v-for="(item, index) in industryList" :key="index" :type="industryValue === item.id ? 'primary' : 'default'" :underline="false" class="mr-5 my-2_5" @click="onChangeIndustry(item)">
                  {{ item.tag }}
                </el-link>
              </div>
            </div> -->
            <!-- <div class="py-2_5">
              <div class="inline-block row-wrap">
                <el-link :underline="false" :type="sort === 'update_time' ? 'primary' : 'default'" class="mr-5 mb-2_5" @click="onChangSort('update_time')">最新</el-link>
                <el-link :underline="false" :type="sort === 'clone_count' ? 'primary' : 'default'" class="mr-5 mb-2_5" @click="onChangSort('clone_count')">热门</el-link>
              </div>
            </div> -->
          </div>

          <div class="my-2_5 mx-2_5">
            <div
              v-if="list && list.items.length <= 0"
              class="my-2_5 has-bg-white border-radius-m has-text-light text-center py-2_5"
            >
              <el-empty :image-size="100" description="暂无数据，可以换个关键词试试哦" />
            </div>

            <div v-if="list && list.items.length > 0" class="border-radius-m" style="overflow:hidden;">
              <div
                v-for="(item) in list.items"
                :key="item.id.toString()"
                class="py-2_5 px-4 has-bg-white cursor-hand"
                style="margin-bottom:1px;"
                @click="onView(item)"
              >
                <div class="row-wrap ">
                  <div class="is-fs-l my-2_5 grow"><i class="iconfont icon-file-text mr-1" /> {{ item.name }}</div>
                  <div class="my-2_5 has-text-light">
                    <span v-show="item.field_count > 0">{{ item.field_count }} 个组件</span>
                    <!-- <span title="更新时间" class="ml-2">{{ formatDate(new Date(item.update_time * 1000), "yyyy-MM-dd") }}</span> -->
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div class="my-2_5 flex-center">
            <el-pagination
              :page-size="perPage"
              layout="prev, pager, next"
              :background="true"
              :total="totalCount"
              :hide-on-single-page="totalCount <= perPage"
              :current-page="pageNo"
              @current-change="onPageChange"
            />
          </div>

          <!-- <div class="my-10 flex-center">
            <a class="el-button el-button--primary is-round" href="https://work.weixin.qq.com/kfid/kfc4c8482f0f4854c58" target="_blank">定制专属模板 联系客服</a>
          </div> -->
        </div>
      </div>
    </div>

    <DlgTplPreview v-model="dlgTplPreview.val" :params="dlgTplPreview.params" />
  </div>
</template>

<script>
import { list2 as tplList } from '@/api/tpl'
import Header from '@/components/Header.vue'
// import Footer from '@/components/Footer.vue'
// import LeftBar from '@/components/LeftBar.vue'
import config from '@/config/index'
import { formatDate } from '@/utils/index'
// import { listTag } from '@/api/util'
import { openPage } from '@/utils/index'
import DlgTplPreview from '@/components/DlgTplPreview.vue'

export default {
  components: {
    // Navbar,
    // Sidebar,
    Header,
    DlgTplPreview
  },
  // filters: {
  //   statusFilter(status) {
  //     const statusMap = {
  //       published: 'success',
  //       draft: 'gray',
  //       deleted: 'danger'
  //     }
  //     return statusMap[status]
  //   }
  // },
  data() {
    return {
      title: '模板',
      list: null,
      pageNo: 1,
      search: '',
      freqSearch: [
        '问卷',
        '考试',
        '登记',
        '预约'
      ],

      scenList: [{ value: '', label: '全部场景', desc: '全部场景' }, ...config.scenList],
      scenValue: '',

      industryList: [],
      industryValue: '',

      sort: 'update_time',

      pagination: {
        size: config.pageSizeM
      },
      dlgTplPreview: {
        val: {
          visible: false
        },
        params: {
          url: '',
          item: null
        }
      }
    }
  },
  computed: {
    dataQuery() {
      let url = `?page=${this.pageNo}`

      if (this.search) {
        url += `&search=${this.search}`
      }
      if (this.sort) {
        url += `&sort=${this.sort}`
      }
      if (this.scenValue) {
        url += `&scen=${this.scenValue}`
      }
      if (this.industryValue) {
        url += `&industry=${this.industryValue}`
      }
      return url
    },
    selList() {
      let list = []
      if (this.list?.items) {
        list = this.list.items.filter((item) => item.selected)
      }

      return list
    },

    perPage() {
      return this.list?._meta?.perPage || 30
    },
    totalCount() {
      return this.list?._meta?.totalCount || 0
    }
  },
  created() { },
  mounted() {
    this.fetchData(this.dataQuery)
    // this.listIndustry()
    // this.listScen()
  },
  methods: {
    formatDate,
    async fetchData(query) {
      const data = await tplList(
        {
          query: query
        },
        'fullLoading'
      )
      console.log(data)
      this.list = data
    },
    // async listScen() {
    //   this.scenList = await listTag(
    //     {
    //       query: `?tag_type=${config.TAG_TYPE_TPL_SCEN}`
    //     },
    //     'listTag'
    //   )
    //   this.scenList.unshift({
    //     id: '',
    //     tag: '全部场景'
    //   })
    // },
    // async listIndustry() {
    //   this.industryList = await listTag(
    //     {
    //       query: `?tag_type=${config.TAG_TYPE_TPL_INDUSTRY}`
    //     },
    //     'listTag'
    //   )
    //   this.industryList.unshift({
    //     id: '',
    //     tag: '全部行业'
    //   })
    // },
    onCreate() {
      const workspaceId = localStorage.getItem('bd_webapp_orgId')
      openPage({
        name: 'FormCreate',
        query: { org_id: workspaceId }
      }, this)
    },
    async onService() {
      const price = `<a class='has-text-primary' href='//bahuyun.com/bd-price.html#rights-support' target='_blank'>会员特权</a>`
      const detail = `<a class="el-button el-button--primary " href="https://work.weixin.qq.com/kfid/kfc4c8482f0f4854c58" target="_blank">
                        <span class="iconfont icon-customerservice" /> 联系专属客服
                      </a>`
      try {
        await this.$msgbox({
          title: '',
          dangerouslyUseHTMLString: true,
          message: `<div class='py-2_5' style='text-align:left;'>
                    <div class="is-bold">免费账号，赠送 <b class='has-text-danger'>1</b> 次录入服务，会员<b class='has-text-danger'>多次</b>，详情请看会员特权页面</b>。${price}</div>
                  </div>
                  <div class='py-2_5 px-4 border-radius-m has-bg-whiteless mb-2_5' style='text-align:left;'>
                    <div>请联系客服，提供表单内容描述，我们会在1个工作日内完成录入：</div>
                    <ol>
                      <li>内容详细描述 / word文档 / excel文档等</li>
                      <li>或者相似表单的链接 / 截图 / 二维码</li>
                      <li>您的八狐表单账号</li>
                    </ol>
           
                  </div>
                  <div class='py-2_5 px-4 border-radius-m has-bg-whiteless' style='text-align:left;'>
                    <div>以下情况不在赠送服务的范围，请您知晓：</div>
                    <ol>
                    <li>包含大量图片的问卷，我们可以帮您录入文档文字，图片需要您自行处理。
                    <li>外语问卷或双语问卷。
                    <li>考试问卷可以录入文档、正确答案，解析不在录入范围内。
                    <li>360度评估如需录入测评关系，需要另算一次录入次数。
                    <li>线下访谈式、面对面访谈式的问卷，不适合使用在线问卷调查的形式。
                    <li>问卷内容为图片格式或不可复制的PDF文档。
                    <li>单个表单组件数不超过100，超过100另算一次录入次数。
                    </ol>
                  </div>
                  <div class='mt-6'>${detail}</div>`,
          iconClass: 'iconfont icon-infomation has-bg-primary upgrade-icon',
          showConfirmButton: false,
          center: true
        })
      } catch (e) {
        console.log(e)
      }
      return
    },
    onSearch(search) {
      this.pageNo = 1
      if (search) {
        this.search = search
      }
      // 至少2个字
      if (this.search.length < 2) {
        this.search = ''
      }
      this.industryValue = null
      this.scenValue = null
      this.sort = 'update_time'
      this.fetchData(this.dataQuery)
    },
    onChangeScen(item) {
      this.pageNo = 1
      this.scenValue = item.value
      this.fetchData(this.dataQuery)
    },
    // onChangeIndustry(item) {
    //   this.pageNo = 1
    //   this.industryValue = item.id
    //   this.fetchData(this.dataQuery)
    // },
    onChangSort(sort) {
      this.pageNo = 1
      this.sort = sort
      this.fetchData(this.dataQuery)
    },
    // 切换页码
    onPageChange(pageNo) {
      this.pageNo = pageNo
      this.fetchData(this.dataQuery)
      scrollTo(0, 0)
    },
    onView(item) {
      this.dlgTplPreview.val.visible = true
      const base = process.env.VUE_APP_PLAYER_BASE_URL
      this.dlgTplPreview.params.url = `${base}/form/${item.id}?action=preview`
      this.dlgTplPreview.params.formId = item.id
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
::v-deep {
  .el-input-group__append {
    border-color: #06F;
    background-color: #06F;
    color: white;
  }
  .el-input__inner {
    border-color: #06F;
  }
}
</style>
